"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ObjectOrderBringForward = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ObjectOrderBringForward_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1H4c-.717 0-1.194 0-1.56.03-.356.03-.518.081-.621.133a1.5 1.5 0 0 0-.656.656c-.052.103-.103.265-.132.62C1 2.806 1 3.283 1 4v4c0 .717 0 1.194.03 1.56.03.356.081.518.133.621a1.5 1.5 0 0 0 .656.655c.103.053.265.104.62.133.162.014.345.021.561.025v1c-.77-.014-1.246-.068-1.635-.267a2.5 2.5 0 0 1-1.093-1.092C0 10.1 0 9.4 0 8V4c0-1.4 0-2.1.272-2.635A2.5 2.5 0 0 1 1.365.272C1.9 0 2.6 0 4 0h4c1.4 0 2.1 0 2.635.272a2.5 2.5 0 0 1 1.092 1.093c.199.389.253.865.268 1.635h-1a9.244 9.244 0 0 0-.026-.56c-.029-.356-.08-.518-.133-.621a1.5 1.5 0 0 0-.655-.656c-.103-.052-.265-.103-.62-.132C9.194 1 8.717 1 8 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12V8c0-1.4 0-2.1.272-2.635a2.5 2.5 0 0 1 1.093-1.093C5.9 4 6.6 4 8 4h4c1.4 0 2.1 0 2.635.272a2.5 2.5 0 0 1 1.092 1.093C16 5.9 16 6.6 16 8v4c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092C14.1 16 13.4 16 12 16H8c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092C4 14.1 4 13.4 4 12Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ObjectOrderBringForward_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ObjectOrderBringForward;
exports["default"] = _default;